import React, { useState } from 'react';
import { ArrowRight, Check, Loader } from 'lucide-react';
import emailjs from '@emailjs/browser';
// Initialize EmailJS once
emailjs.init('d0Y15-C-U3sRrI5-c');
interface WaitlistFormProps {
  'data-id'?: string;
}
export function WaitlistForm({
  'data-id': dataId
}: WaitlistFormProps) {
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !website) {
      setError('Please fill out all required fields');
      return;
    }
    // Auto-fix URL if missing protocol
    let formattedWebsite = website.trim();
    if (!formattedWebsite.startsWith('http://') && !formattedWebsite.startsWith('https://')) {
      formattedWebsite = 'https://' + formattedWebsite;
    }
    // Basic URL validation
    try {
      new URL(formattedWebsite);
    } catch {
      setError('Please enter a valid website URL');
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await emailjs.send('service_2i17xv4', 'template_oyj20m5', {
        email: email,
        website: formattedWebsite,
        to_email: 'chris@naiomi.ai',
        date: new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      });
      if (response.status === 200) {
        setSubmitted(true);
        setEmail('');
        setWebsite('');
      }
    } catch (err) {
      console.error('EmailJS error:', err);
      setError('There was an error submitting the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="waitlist" className="w-full bg-white py-16 px-6 relative overflow-hidden" data-id="element-549">
      {/* Yellow background gradient continuing from Timeline section */}
      <div className="absolute inset-0 bg-gradient-to-b from-benetton-yellow/20 to-benetton-yellow/30 pointer-events-none" data-id="element-550"></div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-551">
        <div className="mx-auto max-w-2xl sm:text-center" data-id="element-552">
          <p className="mt-2 text-3xl font-normal tracking-tight text-benetton-green sm:text-4xl font-apercu" data-id="element-553">
            Keep Up To Date
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600 font-jakarta" data-id="element-554">
            Join 50+ eCommerce merchants already on our waitlist who are ready to transform how they analyze their business.
          </p>
        </div>
        <div className="max-w-2xl mx-auto mt-8" data-id="element-555">
          <div className="bg-white border border-benetton-green rounded-xl p-8 shadow-sm" data-id="element-556">
            {!submitted ? <>
                <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-id="element-557">
                  <div className="flex flex-col gap-2" data-id="element-558">
                    <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-559">
                      Email Address <span className="text-benetton-red" data-id="element-560">*</span>
                    </label>
                    <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="flex-1 px-4 py-3 border border-benetton-green rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-lg" required data-id="element-561" />
                  </div>
                  <div className="flex flex-col gap-2" data-id="element-562">
                    <label htmlFor="website" className="text-sm font-medium text-gray-700" data-id="element-563">
                      Website URL <span className="text-benetton-red" data-id="element-564">*</span>
                    </label>
                    <input id="website" type="text" value={website} onChange={e => setWebsite(e.target.value)} placeholder="yourstore.com or https://yourstore.com" className="flex-1 px-4 py-3 border border-benetton-green rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-lg" required data-id="element-565" />
                  </div>
                  {error && <div className="text-benetton-red text-sm mt-1" data-id="element-566">
                      {error}
                    </div>}
                  <button type="submit" disabled={isSubmitting} className="rounded-md bg-benetton-blue px-3 py-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-benetton-blue/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-benetton-blue font-jakarta flex items-center justify-center mt-2" data-id="element-567">
                    {isSubmitting ? <>
                        <Loader className="animate-spin mr-2 h-5 w-5" data-id="element-568" />
                        Submitting...
                      </> : <>
                        Join Waitlist
                        <ArrowRight className="ml-2 h-5 w-5" data-id="element-569" />
                      </>}
                  </button>
                </form>
              </> : <div className="flex items-center justify-center text-black gap-2 py-3" data-id="element-570">
                <Check className="h-6 w-6" data-id="element-571" />
                <span className="text-lg font-medium" data-id="element-572">
                  Thank you! You're on the list.
                </span>
              </div>}
            <p className="text-sm text-gray-500 mt-4" data-id="element-573">
              We respect your privacy. Your information will only be used for
              updates about Naiomi AI.
            </p>
          </div>
        </div>
      </div>
    </section>;
}